import { render } from "./MaterialInput.vue?vue&type=template&id=1a0c55da"
import script from "./MaterialInput.vue?vue&type=script&lang=js"
export * from "./MaterialInput.vue?vue&type=script&lang=js"

import "./MaterialInput.vue?vue&type=style&index=0&id=1a0c55da&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/MaterialInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a0c55da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a0c55da', __exports__)) {
    api.reload('1a0c55da', __exports__)
  }
  
  module.hot.accept("./MaterialInput.vue?vue&type=template&id=1a0c55da", () => {
    api.rerender('1a0c55da', render)
  })

}


export default __exports__